import { useState, useEffect, useCallback } from "react";

import { API } from "../config";

// ── Stili coerenti con DiarioOperativo.js ─────────────────────────
const FONT = "'DM Sans', sans-serif";
const MONO = "'IBM Plex Mono', monospace";

const stili = {
  card: {
    background: "#fff", borderRadius: 10,
    border: "1px solid #E2E8F0",
    padding: "20px 24px", marginBottom: 16,
    fontFamily: FONT,
  },
  cardTitolo: {
    fontSize: 15, fontWeight: 700, color: "#1E293B",
    margin: "0 0 4px 0", display: "flex", alignItems: "center", gap: 6,
  },
  cardSottotitolo: {
    fontSize: 12, color: "#64748B",
    margin: "0 0 16px 0", lineHeight: 1.5,
  },
  riga: {
    display: "flex", alignItems: "center", gap: 12,
    flexWrap: "wrap",
  },
  label: {
    fontSize: 13, fontWeight: 600, color: "#334155",
    fontFamily: FONT,
  },
  input: {
    fontFamily: MONO, fontSize: 14,
    padding: "8px 10px", borderRadius: 6,
    border: "1px solid #CBD5E1", width: 100,
    color: "#1E293B", outline: "none",
  },
  inputUnit: {
    fontSize: 13, color: "#64748B", fontFamily: FONT,
  },
  bottoneSalva: {
    fontFamily: FONT, fontSize: 13, fontWeight: 600,
    padding: "8px 16px", borderRadius: 6,
    border: "none", background: "#2563EB", color: "#fff",
    cursor: "pointer", transition: "background 0.15s",
  },
  bottoneSalvaDisabled: {
    background: "#94A3B8", cursor: "not-allowed",
  },
  feedbackOk: {
    fontSize: 12, color: "#2E7D32", fontWeight: 600,
    marginTop: 8,
  },
  feedbackErrore: {
    fontSize: 12, color: "#C62828", fontWeight: 600,
    marginTop: 8,
  },
  // ── Tooltip ⓘ ────────────────────────────────────────────────
  tooltipWrapper: {
    position: "relative", display: "inline-flex", alignItems: "center",
  },
  tooltipIcon: {
    width: 16, height: 16, borderRadius: "50%",
    background: "#CBD5E1", color: "#fff",
    fontSize: 11, fontWeight: 700,
    display: "inline-flex", alignItems: "center", justifyContent: "center",
    cursor: "help", fontFamily: FONT,
    userSelect: "none",
  },
  tooltipBox: {
    position: "absolute", top: "calc(100% + 4px)", left: "-12px",
    background: "#1E293B", color: "#fff",
    padding: "10px 12px", borderRadius: 6,
    fontSize: 12, lineHeight: 1.5, fontFamily: FONT, fontWeight: 400,
    width: 320, zIndex: 100,
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    pointerEvents: "none", whiteSpace: "normal", textAlign: "left",
  },
  // ── Placeholder per sezioni in costruzione ───────────────────
  placeholder: {
    background: "#fff", borderRadius: 10,
    border: "1px dashed #CBD5E1", padding: "32px 24px",
    textAlign: "center", color: "#94A3B8",
    fontFamily: FONT, marginBottom: 16,
  },
  placeholderTitolo: {
    fontSize: 14, fontWeight: 600, color: "#64748B",
    marginBottom: 6,
  },
  placeholderTesto: {
    fontSize: 12, color: "#94A3B8",
  },
  // ── Tabella Size% per sistema ────────────────────────────────
  tabella: {
    width: "100%", borderCollapse: "collapse",
    fontFamily: FONT, fontSize: 13,
  },
  th: {
    textAlign: "left", padding: "10px 12px",
    fontWeight: 700, color: "#64748B",
    fontSize: 11, textTransform: "uppercase", letterSpacing: 0.5,
    borderBottom: "1px solid #E2E8F0",
    background: "#F8FAFC",
  },
  thNumerico: {
    textAlign: "right",
  },
  thSistema: {
    width: "1%", whiteSpace: "nowrap",
  },
  td: {
    padding: "10px 12px",
    borderBottom: "1px solid #F1F5F9",
    color: "#1E293B",
  },
  tdNumerico: {
    textAlign: "right", fontFamily: MONO,
  },
  tdSistema: {
    whiteSpace: "nowrap",
  },
  tdAzioni: {
    textAlign: "right", whiteSpace: "nowrap",
  },
  tdEditabile: {
    cursor: "pointer", borderRadius: 4,
    transition: "background 0.15s",
  },
  inputInline: {
    fontFamily: MONO, fontSize: 13,
    padding: "4px 6px", borderRadius: 4,
    border: "1px solid #2563EB", width: 70,
    color: "#1E293B", outline: "none", textAlign: "right",
  },
  feedbackInline: {
    fontSize: 11, fontWeight: 600,
    marginLeft: 8,
  },
  // ── Pulsante "Aggiungi sistema" + dropdown ───────────────────
  toolbarTabella: {
    display: "flex", alignItems: "center", gap: 12,
    marginBottom: 12, position: "relative",
  },
  bottoneAggiungi: {
    fontFamily: FONT, fontSize: 13, fontWeight: 600,
    padding: "8px 14px", borderRadius: 6,
    border: "none", background: "#2563EB", color: "#fff",
    cursor: "pointer", transition: "background 0.15s",
  },
  bottoneAggiungiDisabled: {
    background: "#CBD5E1", cursor: "not-allowed", color: "#fff",
  },
  dropdownBox: {
    position: "absolute", top: "calc(100% + 4px)", left: 0,
    background: "#fff", borderRadius: 6,
    border: "1px solid #E2E8F0",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    minWidth: 240, maxHeight: 320, overflowY: "auto",
    zIndex: 50, fontFamily: FONT,
  },
  dropdownItem: {
    padding: "10px 14px", fontSize: 13,
    color: "#1E293B", cursor: "pointer",
    borderBottom: "1px solid #F1F5F9",
    transition: "background 0.15s",
  },
  dropdownItemUltimo: {
    borderBottom: "none",
  },
  dropdownVuoto: {
    padding: "12px 14px", fontSize: 12,
    color: "#94A3B8", fontStyle: "italic", textAlign: "center",
  },
  // ── Pulsante "Rimuovi" inline ────────────────────────────────
  bottoneRimuovi: {
    fontFamily: FONT, fontSize: 12, fontWeight: 600,
    padding: "4px 10px", borderRadius: 6,
    border: "1px solid #FCA5A5", background: "#fff",
    color: "#C62828", cursor: "pointer",
    transition: "background 0.15s",
  },
  // ── Modal conferma rimozione ─────────────────────────────────
  modalOverlay: {
    position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
    background: "rgba(15, 23, 42, 0.4)",
    display: "flex", alignItems: "center", justifyContent: "center",
    zIndex: 1000,
  },
  modalBox: {
    background: "#fff", borderRadius: 10,
    padding: "24px 28px", maxWidth: 460,
    boxShadow: "0 12px 32px rgba(0,0,0,0.2)",
    fontFamily: FONT,
  },
  modalTitolo: {
    fontSize: 16, fontWeight: 700, color: "#1E293B",
    marginBottom: 10,
  },
  modalTesto: {
    fontSize: 13, color: "#475569", lineHeight: 1.5,
    marginBottom: 20,
  },
  modalAzioni: {
    display: "flex", justifyContent: "flex-end", gap: 8,
  },
  bottoneModalAnnulla: {
    fontFamily: FONT, fontSize: 13, fontWeight: 600,
    padding: "8px 14px", borderRadius: 6,
    border: "1px solid #CBD5E1", background: "#fff",
    color: "#64748B", cursor: "pointer",
  },
  bottoneModalConferma: {
    fontFamily: FONT, fontSize: 13, fontWeight: 600,
    padding: "8px 14px", borderRadius: 6,
    border: "none", background: "#DC2626", color: "#fff",
    cursor: "pointer",
  },
  bottoneModalSalva: {
    fontFamily: FONT, fontSize: 13, fontWeight: 600,
    padding: "8px 14px", borderRadius: 6,
    border: "none", background: "#2563EB", color: "#fff",
    cursor: "pointer",
  },
  // ── Form dentro il modal stagioni ────────────────────────────
  modalForm: {
    display: "flex", flexDirection: "column", gap: 14,
    marginBottom: 20,
  },
  modalFormRiga: {
    display: "flex", flexDirection: "column", gap: 4,
  },
  modalFormLabel: {
    fontSize: 12, fontWeight: 600, color: "#475569",
    fontFamily: FONT,
  },
  modalFormInput: {
    fontFamily: FONT, fontSize: 14,
    padding: "8px 10px", borderRadius: 6,
    border: "1px solid #CBD5E1",
    color: "#1E293B", outline: "none",
    width: "100%", boxSizing: "border-box",
  },
  modalFormHint: {
    fontSize: 11, color: "#94A3B8", fontStyle: "italic",
    marginTop: 2,
  },
  modalFormErrore: {
    fontSize: 12, color: "#C62828", fontWeight: 600,
    marginBottom: 12,
  },
  // ── Badge "in corso" per stagioni senza data fine ────────────
  badgeInCorso: {
    display: "inline-block", padding: "2px 8px",
    borderRadius: 12, fontSize: 11, fontWeight: 600,
    background: "#DBEAFE", color: "#1E40AF",
    fontFamily: FONT,
  },
  // ── Pulsante "Modifica" inline ───────────────────────────────
  bottoneModifica: {
    fontFamily: FONT, fontSize: 12, fontWeight: 600,
    padding: "4px 10px", borderRadius: 6,
    border: "1px solid #CBD5E1", background: "#fff",
    color: "#475569", cursor: "pointer",
    transition: "background 0.15s",
    marginRight: 6,
  },
};

// ── Tooltip ⓘ con hover ────────────────────────────────────────
function Tooltip({ testo }) {
  const [visibile, setVisibile] = useState(false);
  return (
    <span
      style={stili.tooltipWrapper}
      onMouseEnter={() => setVisibile(true)}
      onMouseLeave={() => setVisibile(false)}
    >
      <span style={stili.tooltipIcon}>i</span>
      {visibile && <span style={stili.tooltipBox}>{testo}</span>}
    </span>
  );
}

// ── Sezione: Reminder revisione capitale ───────────────────────
function SezioneReminderCapitale({ valoreIniziale, onSalvato }) {
  const [valore, setValore] = useState(valoreIniziale ?? "");
  const [salvataggio, setSalvataggio] = useState(false);
  const [feedback, setFeedback] = useState(null);

  useEffect(() => {
    setValore(valoreIniziale ?? "");
  }, [valoreIniziale]);

  useEffect(() => {
    if (feedback) {
      const t = setTimeout(() => setFeedback(null), 3000);
      return () => clearTimeout(t);
    }
  }, [feedback]);

  const handleSalva = async () => {
    const num = parseInt(String(valore), 10);
    if (isNaN(num) || num < 1 || num > 365) {
      setFeedback({ tipo: "errore", testo: "Valore non valido (atteso 1-365)" });
      return;
    }
    setSalvataggio(true);
    setFeedback(null);
    try {
      const r = await fetch(`${API}/diario/impostazioni`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ reminder_capitale_giorni: num }),
      });
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const data = await r.json();
      if (data.errore) throw new Error(data.errore);
      setFeedback({ tipo: "ok", testo: "✓ Salvato" });
      if (onSalvato) onSalvato(data);
    } catch (e) {
      setFeedback({ tipo: "errore", testo: `Errore: ${e.message}` });
    } finally {
      setSalvataggio(false);
    }
  };

  return (
    <div style={stili.card}>
      <div style={stili.cardTitolo}>Reminder revisione capitale</div>
      <div style={stili.cardSottotitolo}>
        Ogni quanti giorni l'app ti ricorderà di rivedere il capitale di riferimento.
        Valore consigliato: 90 giorni (3 mesi).
      </div>
      <div style={stili.riga}>
        <span style={stili.label}>Frequenza:</span>
        <input
          type="text"
          style={stili.input}
          value={valore}
          onChange={(e) => setValore(e.target.value)}
          placeholder="90"
        />
        <span style={stili.inputUnit}>giorni</span>
        <button
          style={{
            ...stili.bottoneSalva,
            ...(salvataggio ? stili.bottoneSalvaDisabled : {}),
          }}
          onClick={handleSalva}
          disabled={salvataggio}
        >
          {salvataggio ? "Salvataggio..." : "💾 Salva"}
        </button>
      </div>
      {feedback && (
        <div style={feedback.tipo === "ok" ? stili.feedbackOk : stili.feedbackErrore}>
          {feedback.testo}
        </div>
      )}
    </div>
  );
}

// ── Componente principale ──────────────────────────────────────
// ── Sezione: Size% per sistema (tabella editabile inline) ─────
function SezioneSizePerSistema() {
  const [righe, setRighe] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errore, setErrore] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [editValue, setEditValue] = useState("");
  const [salvataggioId, setSalvataggioId] = useState(null);
  const [feedbackId, setFeedbackId] = useState(null); // { sistema_id, tipo, testo }

  // Stato dropdown "Aggiungi sistema"
  const [disponibili, setDisponibili] = useState([]);
  const [loadingDisp, setLoadingDisp] = useState(false);
  const [dropdownAperto, setDropdownAperto] = useState(false);
  const [aggiungendoId, setAggiungendoId] = useState(null);

  // Stato modal conferma rimozione
  const [modalRimuovi, setModalRimuovi] = useState(null); // { sistema_id, nome_sistema }
  const [rimuovendoId, setRimuovendoId] = useState(null);

  const ricarica = useCallback(async () => {
    setLoading(true);
    setErrore(null);
    try {
      const r = await fetch(`${API}/diario/size-per-sistema`);
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const data = await r.json();
      setRighe(Array.isArray(data) ? data : []);
    } catch (e) {
      setErrore(e.message || "Errore di rete");
    } finally {
      setLoading(false);
    }
  }, []);

  const ricaricaDisponibili = useCallback(async () => {
    setLoadingDisp(true);
    try {
      const r = await fetch(`${API}/diario/sistemi-disponibili`);
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const data = await r.json();
      setDisponibili(Array.isArray(data) ? data : []);
    } catch (e) {
      setDisponibili([]);
    } finally {
      setLoadingDisp(false);
    }
  }, []);

  useEffect(() => {
    ricarica();
    ricaricaDisponibili();
  }, [ricarica, ricaricaDisponibili]);

  // Auto-nascondi feedback dopo 3 secondi
  useEffect(() => {
    if (feedbackId) {
      const t = setTimeout(() => setFeedbackId(null), 3000);
      return () => clearTimeout(t);
    }
  }, [feedbackId]);

  // Chiudi dropdown se clicco fuori
  useEffect(() => {
    if (!dropdownAperto) return;
    const handleClickOut = (e) => {
      // Lascio il click gestire i suoi handler interni; chiudo al click successivo
      // su elementi fuori dal toolbar (semplicemente al mousedown su body)
      const target = e.target;
      if (target && target.closest && target.closest("[data-dropdown-aggiungi]")) return;
      setDropdownAperto(false);
    };
    document.addEventListener("mousedown", handleClickOut);
    return () => document.removeEventListener("mousedown", handleClickOut);
  }, [dropdownAperto]);

  const apriEdit = (riga) => {
    setEditingId(riga.sistema_id);
    const v = riga.size_pct_default;
    setEditValue(v != null ? String(v).replace(".", ",") : "");
  };

  const annullaEdit = () => {
    setEditingId(null);
    setEditValue("");
  };

  const salvaEdit = async (sistema_id) => {
    const num = parseFloat(String(editValue).replace(",", "."));
    if (isNaN(num) || num < 0 || num > 100) {
      setFeedbackId({ sistema_id, tipo: "errore", testo: "Valore non valido" });
      return;
    }
    setSalvataggioId(sistema_id);
    setFeedbackId(null);
    try {
      const r = await fetch(
        `${API}/diario/size-per-sistema/${encodeURIComponent(sistema_id)}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ size_pct_default: num }),
        }
      );
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const data = await r.json();
      if (data.errore) throw new Error(data.errore);
      setRighe((prev) =>
        prev.map((row) =>
          row.sistema_id === sistema_id
            ? { ...row, size_pct_default: data.size_pct_default }
            : row
        )
      );
      setEditingId(null);
      setEditValue("");
      setFeedbackId({ sistema_id, tipo: "ok", testo: "✓ Salvato" });
    } catch (e) {
      setFeedbackId({ sistema_id, tipo: "errore", testo: `Errore: ${e.message}` });
    } finally {
      setSalvataggioId(null);
    }
  };

  const handleKey = (e, sistema_id) => {
    if (e.key === "Enter") salvaEdit(sistema_id);
    else if (e.key === "Escape") annullaEdit();
  };

  const formatPctIt = (v) => {
    if (v == null) return "—";
    return Number(v).toLocaleString("it-IT", {
      minimumFractionDigits: 1, maximumFractionDigits: 2,
    });
  };

  // Aggiungi sistema dal dropdown
  const aggiungiSistema = async (sistema) => {
    setAggiungendoId(sistema.sistema_id);
    try {
      const r = await fetch(`${API}/diario/size-per-sistema`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ sistema_id: sistema.sistema_id }),
      });
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const data = await r.json();
      if (data.errore) throw new Error(data.errore);
      // Aggiorno tabella e disponibili in locale
      setRighe((prev) => [
        ...prev,
        {
          sistema_id: sistema.sistema_id,
          nome_sistema: sistema.nome_sistema,
          size_pct_default: data.size_pct_default,
        },
      ].sort((a, b) =>
        (a.nome_sistema || "").toLowerCase().localeCompare((b.nome_sistema || "").toLowerCase())
      ));
      setDisponibili((prev) => prev.filter((s) => s.sistema_id !== sistema.sistema_id));
      setDropdownAperto(false);
      setFeedbackId({ sistema_id: sistema.sistema_id, tipo: "ok", testo: "✓ Aggiunto" });
    } catch (e) {
      setFeedbackId({ sistema_id: sistema.sistema_id, tipo: "errore", testo: `Errore: ${e.message}` });
    } finally {
      setAggiungendoId(null);
    }
  };

  // Conferma rimozione
  const confermaRimozione = async () => {
    if (!modalRimuovi) return;
    const sistema_id = modalRimuovi.sistema_id;
    const nome_sistema = modalRimuovi.nome_sistema;
    setRimuovendoId(sistema_id);
    try {
      const r = await fetch(
        `${API}/diario/size-per-sistema/${encodeURIComponent(sistema_id)}`,
        { method: "DELETE" }
      );
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const data = await r.json();
      if (data.errore) throw new Error(data.errore);
      // Rimuovo da tabella e aggiungo ai disponibili in locale
      setRighe((prev) => prev.filter((row) => row.sistema_id !== sistema_id));
      setDisponibili((prev) => [
        ...prev,
        { sistema_id, nome_sistema },
      ].sort((a, b) =>
        (a.nome_sistema || "").toLowerCase().localeCompare((b.nome_sistema || "").toLowerCase())
      ));
      setModalRimuovi(null);
    } catch (e) {
      setFeedbackId({ sistema_id, tipo: "errore", testo: `Errore: ${e.message}` });
      setModalRimuovi(null);
    } finally {
      setRimuovendoId(null);
    }
  };

  const dropdownVuoto = !loadingDisp && disponibili.length === 0;
  const tuttiInDiario = dropdownVuoto;

  return (
    <div style={stili.card}>
      <div style={stili.cardTitolo}>Size% per sistema</div>
      <div style={stili.cardSottotitolo}>
        Percentuale del capitale assegnata a ogni sistema. Clicca sul valore della colonna "Size%" per modificarlo.
      </div>

      {/* Toolbar: pulsante Aggiungi sistema */}
      <div style={stili.toolbarTabella} data-dropdown-aggiungi="true">
        <button
          style={{
            ...stili.bottoneAggiungi,
            ...(tuttiInDiario ? stili.bottoneAggiungiDisabled : {}),
          }}
          onClick={() => {
            if (tuttiInDiario) return;
            setDropdownAperto((v) => !v);
          }}
          disabled={tuttiInDiario}
          title={tuttiInDiario ? "Tutti i sistemi sono già nel Diario" : ""}
        >
          {tuttiInDiario
            ? "Tutti i sistemi sono già nel Diario"
            : "➕ Aggiungi sistema al Diario"}
        </button>

        {dropdownAperto && (
          <div style={stili.dropdownBox}>
            {loadingDisp && (
              <div style={stili.dropdownVuoto}>Caricamento...</div>
            )}
            {!loadingDisp && disponibili.length === 0 && (
              <div style={stili.dropdownVuoto}>
                Nessun sistema disponibile da aggiungere.
              </div>
            )}
            {!loadingDisp && disponibili.map((sistema, idx) => {
              const isLast = idx === disponibili.length - 1;
              const inAggiunta = aggiungendoId === sistema.sistema_id;
              return (
                <div
                  key={sistema.sistema_id}
                  style={{
                    ...stili.dropdownItem,
                    ...(isLast ? stili.dropdownItemUltimo : {}),
                    ...(inAggiunta ? { background: "#F1F5F9", cursor: "wait" } : {}),
                  }}
                  onClick={() => !inAggiunta && aggiungiSistema(sistema)}
                  onMouseEnter={(e) => {
                    if (!inAggiunta) e.currentTarget.style.background = "#F8FAFC";
                  }}
                  onMouseLeave={(e) => {
                    if (!inAggiunta) e.currentTarget.style.background = "transparent";
                  }}
                >
                  {sistema.nome_sistema || sistema.sistema_id}
                  {inAggiunta && (
                    <span style={{ marginLeft: 8, fontSize: 11, color: "#64748B" }}>
                      Aggiungo...
                    </span>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>

      {loading && (
        <div style={{ fontSize: 13, color: "#64748B" }}>Caricamento...</div>
      )}

      {errore && (
        <div style={{ fontSize: 13, color: "#C62828" }}>
          Errore: {errore}
        </div>
      )}

      {!loading && !errore && righe.length === 0 && (
        <div style={{ fontSize: 13, color: "#94A3B8", fontStyle: "italic" }}>
          Nessun sistema nel Diario. Usa il pulsante "➕ Aggiungi sistema al Diario" per inserirne uno.
        </div>
      )}

      {!loading && !errore && righe.length > 0 && (
        <table style={stili.tabella}>
          <thead>
            <tr>
              <th style={{ ...stili.th, ...stili.thSistema }}>Sistema</th>
              <th style={stili.th}>
                <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                  Size%
                  <Tooltip testo="Quando aggiungi un nuovo sistema, viene preimpostato con un size pari all'1% del capitale corrente. Puoi modificare questa percentuale per il singolo sistema cliccando sul valore nella colonna 'Size%'." />
                </span>
              </th>
              <th style={{ ...stili.th, ...stili.thNumerico }}>Azioni</th>
            </tr>
          </thead>
          <tbody>
            {righe.map((row) => {
              const inEdit = editingId === row.sistema_id;
              const inSalvataggio = salvataggioId === row.sistema_id;
              const inRimozione = rimuovendoId === row.sistema_id;
              const fb = feedbackId && feedbackId.sistema_id === row.sistema_id ? feedbackId : null;
              return (
                <tr key={row.sistema_id}>
                  <td style={{ ...stili.td, ...stili.tdSistema }}>
                    {row.nome_sistema || row.sistema_id}
                  </td>
                  <td style={stili.td}>
                    {inEdit ? (
                      <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                        <input
                          type="text"
                          autoFocus
                          style={stili.inputInline}
                          value={editValue}
                          onChange={(e) => setEditValue(e.target.value)}
                          onKeyDown={(e) => handleKey(e, row.sistema_id)}
                          disabled={inSalvataggio}
                        />
                        <span style={{ fontSize: 12, color: "#64748B" }}>%</span>
                        <button
                          style={{
                            ...stili.bottoneSalva,
                            padding: "4px 10px", fontSize: 12,
                            ...(inSalvataggio ? stili.bottoneSalvaDisabled : {}),
                          }}
                          onClick={() => salvaEdit(row.sistema_id)}
                          disabled={inSalvataggio}
                        >
                          {inSalvataggio ? "..." : "Salva"}
                        </button>
                        <button
                          style={{
                            fontFamily: FONT, fontSize: 12, fontWeight: 600,
                            padding: "4px 10px", borderRadius: 6,
                            border: "1px solid #CBD5E1", background: "#fff",
                            color: "#64748B", cursor: "pointer",
                          }}
                          onClick={annullaEdit}
                          disabled={inSalvataggio}
                        >
                          Annulla
                        </button>
                      </span>
                    ) : (
                      <span
                        style={{
                          ...stili.tdEditabile,
                          padding: "4px 8px", display: "inline-block",
                          fontFamily: MONO,
                        }}
                        onClick={() => apriEdit(row)}
                        onMouseEnter={(e) => (e.currentTarget.style.background = "#F1F5F9")}
                        onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                        title="Clicca per modificare"
                      >
                        {formatPctIt(row.size_pct_default)} %
                      </span>
                    )}
                    {fb && (
                      <span
                        style={{
                          ...stili.feedbackInline,
                          color: fb.tipo === "ok" ? "#2E7D32" : "#C62828",
                        }}
                      >
                        {fb.testo}
                      </span>
                    )}
                  </td>
                  <td style={{ ...stili.td, ...stili.tdAzioni }}>
                    <button
                      style={stili.bottoneRimuovi}
                      onClick={() =>
                        setModalRimuovi({
                          sistema_id: row.sistema_id,
                          nome_sistema: row.nome_sistema || row.sistema_id,
                        })
                      }
                      disabled={inRimozione || inEdit}
                      onMouseEnter={(e) => {
                        if (!inRimozione && !inEdit) e.currentTarget.style.background = "#FEF2F2";
                      }}
                      onMouseLeave={(e) => {
                        if (!inRimozione && !inEdit) e.currentTarget.style.background = "#fff";
                      }}
                      title="Rimuovi questo sistema dal Diario"
                    >
                      🗑️ Rimuovi
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}

      {/* Modal conferma rimozione */}
      {modalRimuovi && (
        <div style={stili.modalOverlay} onClick={() => setModalRimuovi(null)}>
          <div style={stili.modalBox} onClick={(e) => e.stopPropagation()}>
            <div style={stili.modalTitolo}>Rimuovere "{modalRimuovi.nome_sistema}" dal Diario?</div>
            <div style={stili.modalTesto}>
              Il sistema <strong>non verrà eliminato</strong> dalla web app. Le operazioni
              passate registrate nel Diario per questo sistema <strong>resteranno visibili</strong>.
              <br /><br />
              Verrà rimosso solo dalla tabella di gestione del Size% qui sopra. Potrai
              riaggiungerlo in qualsiasi momento.
            </div>
            <div style={stili.modalAzioni}>
              <button
                style={stili.bottoneModalAnnulla}
                onClick={() => setModalRimuovi(null)}
                disabled={rimuovendoId !== null}
              >
                Annulla
              </button>
              <button
                style={{
                  ...stili.bottoneModalConferma,
                  ...(rimuovendoId !== null ? { opacity: 0.6, cursor: "wait" } : {}),
                }}
                onClick={confermaRimozione}
                disabled={rimuovendoId !== null}
              >
                {rimuovendoId !== null ? "Rimozione..." : "Conferma rimozione"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Sezione: Stagioni (CRUD con modal) ─────────────────────────
function SezioneStagioni({ onCapitaliCambiati } = {}) {
  const [righe, setRighe] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errore, setErrore] = useState(null);

  // Stato modal aggiungi/modifica
  // modalAttivo: null | { mode: 'add'|'edit', id?, etichetta, data_inizio, data_fine }
  const [modalAttivo, setModalAttivo] = useState(null);
  const [erroreForm, setErroreForm] = useState(null);
  const [salvataggio, setSalvataggio] = useState(false);

  // Stato modal conferma eliminazione
  const [modalElimina, setModalElimina] = useState(null); // { id, etichetta }
  const [eliminandoId, setEliminandoId] = useState(null);

  const ricarica = useCallback(async () => {
    setLoading(true);
    setErrore(null);
    try {
      const r = await fetch(`${API}/diario/stagioni`);
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const data = await r.json();
      setRighe(Array.isArray(data) ? data : []);
    } catch (e) {
      setErrore(e.message || "Errore di rete");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    ricarica();
  }, [ricarica]);

  // Apri modal in modalita' aggiungi (campi vuoti)
  const apriAggiungi = () => {
    setErroreForm(null);
    setModalAttivo({
      mode: "add",
      etichetta: "",
      data_inizio: "",
      data_fine: "",
      capitale_inizio_stagione_eur: "",
      capitale_operativo_eur: "",
    });
  };

  // Apri modal in modalita' modifica (campi precompilati)
  const apriModifica = (riga) => {
    setErroreForm(null);
    setModalAttivo({
      mode: "edit",
      id: riga.id,
      etichetta: riga.etichetta || "",
      data_inizio: riga.data_inizio || "",
      data_fine: riga.data_fine || "",
      capitale_inizio_stagione_eur:
        riga.capitale_inizio_stagione_eur != null
          ? String(riga.capitale_inizio_stagione_eur)
          : "",
      capitale_operativo_eur:
        riga.capitale_operativo_eur != null
          ? String(riga.capitale_operativo_eur)
          : "",
    });
  };

  const chiudiModal = () => {
    if (salvataggio) return;
    setModalAttivo(null);
    setErroreForm(null);
  };

  const aggiornaCampo = (campo, valore) => {
    setModalAttivo((prev) => prev && { ...prev, [campo]: valore });
  };

  const salvaModal = async () => {
    if (!modalAttivo) return;
    const {
      mode, id, etichetta, data_inizio, data_fine,
      capitale_inizio_stagione_eur, capitale_operativo_eur,
    } = modalAttivo;

    // Validazioni base
    if (!etichetta || !etichetta.trim()) {
      setErroreForm("L'etichetta è obbligatoria.");
      return;
    }
    if (!data_inizio) {
      setErroreForm("La data di inizio è obbligatoria.");
      return;
    }
    if (data_fine && data_fine < data_inizio) {
      setErroreForm("La data di fine non può essere precedente alla data di inizio.");
      return;
    }

    // Validazione capitali (solo se valorizzati)
    let capInizio = null;
    let capOperativo = null;
    if (capitale_inizio_stagione_eur !== "" && capitale_inizio_stagione_eur != null) {
      const v = Number(capitale_inizio_stagione_eur);
      if (!isFinite(v) || v <= 0) {
        setErroreForm("Il capitale di inizio stagione deve essere un numero maggiore di zero.");
        return;
      }
      capInizio = v;
    }
    if (capitale_operativo_eur !== "" && capitale_operativo_eur != null) {
      const v = Number(capitale_operativo_eur);
      if (!isFinite(v) || v <= 0) {
        setErroreForm("Il capitale operativo deve essere un numero maggiore di zero.");
        return;
      }
      capOperativo = v;
    }

    const payload = {
      etichetta: etichetta.trim(),
      data_inizio,
      data_fine: data_fine || null,
      capitale_inizio_stagione_eur: capInizio,
      capitale_operativo_eur: capOperativo,
    };

    setSalvataggio(true);
    setErroreForm(null);
    try {
      let url = `${API}/diario/stagioni`;
      let method = "POST";
      if (mode === "edit") {
        url = `${API}/diario/stagioni/${id}`;
        method = "PUT";
      }
      const r = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const data = await r.json();
      if (data.errore) throw new Error(data.errore);

      // Aggiorno tabella in locale
      if (mode === "add") {
        setRighe((prev) => [data, ...prev].sort((a, b) =>
          (b.data_inizio || "").localeCompare(a.data_inizio || "")
        ));
      } else {
        setRighe((prev) =>
          prev.map((row) => (row.id === id ? data : row))
            .sort((a, b) => (b.data_inizio || "").localeCompare(a.data_inizio || ""))
        );
      }
      setModalAttivo(null);
      if (typeof onCapitaliCambiati === "function") onCapitaliCambiati();
    } catch (e) {
      setErroreForm(`Errore: ${e.message}`);
    } finally {
      setSalvataggio(false);
    }
  };

  const confermaElimina = async () => {
    if (!modalElimina) return;
    const id = modalElimina.id;
    setEliminandoId(id);
    try {
      const r = await fetch(`${API}/diario/stagioni/${id}`, { method: "DELETE" });
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const data = await r.json();
      if (data.errore) throw new Error(data.errore);
      setRighe((prev) => prev.filter((row) => row.id !== id));
      setModalElimina(null);
      if (typeof onCapitaliCambiati === "function") onCapitaliCambiati();
    } catch (e) {
      // In caso di errore lo segnalo nello stesso modal
      setModalElimina((prev) => prev && { ...prev, errore: e.message });
    } finally {
      setEliminandoId(null);
    }
  };

  const formatData = (s) => {
    if (!s) return "";
    // s = "YYYY-MM-DD" -> "DD/MM/YYYY"
    const parts = s.split("-");
    if (parts.length !== 3) return s;
    return `${parts[2]}/${parts[1]}/${parts[0]}`;
  };

  // v125: format euro con separatore migliaia "." e decimale ","
  const formatEurStagione = (v) => {
    if (v === null || v === undefined || v === "") return "—";
    const n = Number(v);
    if (!isFinite(n)) return "—";
    const intero = Math.trunc(Math.abs(n));
    const dec = Math.round((Math.abs(n) - intero) * 100);
    const interoStr = String(intero).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    const decStr = String(dec).padStart(2, "0");
    return (n < 0 ? "-" : "") + interoStr + "," + decStr + " €";
  };

  // v125: pulsante "Allinea al corrente" — legge l'endpoint /diario/capitale/stato
  // e copia il capitale_corrente nel campo capitale_operativo_eur del modal.
  const allineaAlCorrente = async () => {
    try {
      const r = await fetch(`${API}/diario/capitale/stato`);
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const data = await r.json();
      const corrente = Number(data?.capitale_corrente);
      if (!isFinite(corrente) || corrente <= 0) {
        setErroreForm("Capitale corrente non disponibile o pari a zero.");
        return;
      }
      setModalAttivo((prev) => prev && {
        ...prev,
        capitale_operativo_eur: String(corrente.toFixed(2)),
      });
    } catch (e) {
      setErroreForm(`Errore lettura capitale corrente: ${e.message}`);
    }
  };

  return (
    <div style={stili.card}>
      <div style={stili.cardTitolo}>Stagioni</div>
      <div style={stili.cardSottotitolo}>
        Definisci le stagioni del tuo Diario. Una stagione senza data di fine è considerata "in corso".
      </div>

      <div style={stili.toolbarTabella}>
        <button style={stili.bottoneAggiungi} onClick={apriAggiungi}>
          ➕ Aggiungi stagione
        </button>
      </div>

      {loading && (
        <div style={{ fontSize: 13, color: "#64748B" }}>Caricamento...</div>
      )}

      {errore && (
        <div style={{ fontSize: 13, color: "#C62828" }}>Errore: {errore}</div>
      )}

      {!loading && !errore && righe.length === 0 && (
        <div style={{ fontSize: 13, color: "#94A3B8", fontStyle: "italic" }}>
          Nessuna stagione presente. Usa il pulsante "➕ Aggiungi stagione" per inserirne una.
        </div>
      )}

      {!loading && !errore && righe.length > 0 && (
        <table style={stili.tabella}>
          <thead>
            <tr>
              <th style={stili.th}>Etichetta</th>
              <th style={stili.th}>Data inizio</th>
              <th style={stili.th}>Data fine</th>
              <th
                style={{ ...stili.th, ...stili.thNumerico }}
                title="Valore di partenza della stagione. Statico, immutabile per tutta la stagione."
              >
                Cap. inizio stagione
              </th>
              <th
                style={{ ...stili.th, ...stili.thNumerico }}
                title="Base per il calcolo dello stake. Aggiornalo quando vuoi allinearlo al Capitale corrente."
              >
                Cap. operativo
              </th>
              <th style={{ ...stili.th, ...stili.thNumerico }}>Azioni</th>
            </tr>
          </thead>
          <tbody>
            {righe.map((row) => (
              <tr key={row.id}>
                <td style={stili.td}>{row.etichetta || "—"}</td>
                <td style={stili.td}>{formatData(row.data_inizio)}</td>
                <td style={stili.td}>
                  {row.data_fine
                    ? formatData(row.data_fine)
                    : <span style={stili.badgeInCorso}>in corso</span>}
                </td>
                <td style={{ ...stili.td, ...stili.tdNumerico }}>
                  {formatEurStagione(row.capitale_inizio_stagione_eur)}
                </td>
                <td style={{ ...stili.td, ...stili.tdNumerico }}>
                  {formatEurStagione(row.capitale_operativo_eur)}
                </td>
                <td style={{ ...stili.td, ...stili.tdAzioni }}>
                  <button
                    style={stili.bottoneModifica}
                    onClick={() => apriModifica(row)}
                    onMouseEnter={(e) => (e.currentTarget.style.background = "#F1F5F9")}
                    onMouseLeave={(e) => (e.currentTarget.style.background = "#fff")}
                    title="Modifica questa stagione"
                  >
                    ✏️ Modifica
                  </button>
                  <button
                    style={stili.bottoneRimuovi}
                    onClick={() => setModalElimina({ id: row.id, etichetta: row.etichetta })}
                    onMouseEnter={(e) => (e.currentTarget.style.background = "#FEF2F2")}
                    onMouseLeave={(e) => (e.currentTarget.style.background = "#fff")}
                    title="Elimina questa stagione"
                  >
                    🗑️ Elimina
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Modal aggiungi/modifica */}
      {modalAttivo && (
        <div style={stili.modalOverlay} onClick={chiudiModal}>
          <div style={stili.modalBox} onClick={(e) => e.stopPropagation()}>
            <div style={stili.modalTitolo}>
              {modalAttivo.mode === "add" ? "Aggiungi nuova stagione" : "Modifica stagione"}
            </div>

            <div style={stili.modalForm}>
              <div style={stili.modalFormRiga}>
                <label style={stili.modalFormLabel}>Etichetta</label>
                <input
                  type="text"
                  style={stili.modalFormInput}
                  value={modalAttivo.etichetta}
                  onChange={(e) => aggiornaCampo("etichetta", e.target.value)}
                  placeholder="Es. 2025/2026"
                  disabled={salvataggio}
                  autoFocus
                />
              </div>

              <div style={stili.modalFormRiga}>
                <label style={stili.modalFormLabel}>Data inizio</label>
                <input
                  type="date"
                  style={stili.modalFormInput}
                  value={modalAttivo.data_inizio}
                  onChange={(e) => aggiornaCampo("data_inizio", e.target.value)}
                  disabled={salvataggio}
                />
              </div>

              <div style={stili.modalFormRiga}>
                <label style={stili.modalFormLabel}>Data fine (opzionale)</label>
                <input
                  type="date"
                  style={stili.modalFormInput}
                  value={modalAttivo.data_fine}
                  onChange={(e) => aggiornaCampo("data_fine", e.target.value)}
                  disabled={salvataggio}
                />
                <span style={stili.modalFormHint}>
                  Lascia vuoto per "stagione in corso"
                </span>
              </div>

              <div style={stili.modalFormRiga}>
                <label
                  style={stili.modalFormLabel}
                  title="Valore di partenza della stagione. Statico, immutabile per tutta la stagione."
                >
                  Capitale di inizio stagione (€)
                </label>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  style={stili.modalFormInput}
                  value={modalAttivo.capitale_inizio_stagione_eur}
                  onChange={(e) => aggiornaCampo("capitale_inizio_stagione_eur", e.target.value)}
                  placeholder="Es. 10000"
                  disabled={salvataggio}
                />
              </div>

              <div style={stili.modalFormRiga}>
                <label
                  style={stili.modalFormLabel}
                  title="Base per il calcolo dello stake. Aggiornalo quando vuoi allinearlo al Capitale corrente."
                >
                  Capitale operativo (€)
                </label>
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    style={{ ...stili.modalFormInput, flex: 1 }}
                    value={modalAttivo.capitale_operativo_eur}
                    onChange={(e) => aggiornaCampo("capitale_operativo_eur", e.target.value)}
                    placeholder="Es. 10000"
                    disabled={salvataggio}
                  />
                  <button
                    type="button"
                    style={{
                      ...stili.bottoneAggiungi,
                      padding: "8px 12px", fontSize: 12,
                      whiteSpace: "nowrap",
                      ...(salvataggio ? { opacity: 0.5, cursor: "not-allowed" } : {}),
                    }}
                    onClick={allineaAlCorrente}
                    disabled={salvataggio}
                    title="Imposta il Capitale operativo uguale al Capitale corrente attuale"
                  >
                    Allinea al corrente
                  </button>
                </div>
                <span style={stili.modalFormHint}>
                  All'inizio della stagione coincide con il Capitale di inizio stagione.
                </span>
              </div>
            </div>

            {erroreForm && (
              <div style={stili.modalFormErrore}>{erroreForm}</div>
            )}

            <div style={stili.modalAzioni}>
              <button
                style={stili.bottoneModalAnnulla}
                onClick={chiudiModal}
                disabled={salvataggio}
              >
                Annulla
              </button>
              <button
                style={{
                  ...stili.bottoneModalSalva,
                  ...(salvataggio ? { opacity: 0.6, cursor: "wait" } : {}),
                }}
                onClick={salvaModal}
                disabled={salvataggio}
              >
                {salvataggio ? "Salvataggio..." : "💾 Salva"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal conferma eliminazione */}
      {modalElimina && (
        <div style={stili.modalOverlay} onClick={() => setModalElimina(null)}>
          <div style={stili.modalBox} onClick={(e) => e.stopPropagation()}>
            <div style={stili.modalTitolo}>
              Eliminare la stagione "{modalElimina.etichetta}"?
            </div>
            <div style={stili.modalTesto}>
              L'operazione è permanente. Le operazioni del Diario registrate
              in questa stagione <strong>resteranno visibili</strong>: l'etichetta
              di stagione viene calcolata in base alle date, quindi cambierà solo
              il filtro "stagione" della tabella operazioni.
            </div>
            {modalElimina.errore && (
              <div style={stili.modalFormErrore}>Errore: {modalElimina.errore}</div>
            )}
            <div style={stili.modalAzioni}>
              <button
                style={stili.bottoneModalAnnulla}
                onClick={() => setModalElimina(null)}
                disabled={eliminandoId !== null}
              >
                Annulla
              </button>
              <button
                style={{
                  ...stili.bottoneModalConferma,
                  ...(eliminandoId !== null ? { opacity: 0.6, cursor: "wait" } : {}),
                }}
                onClick={confermaElimina}
                disabled={eliminandoId !== null}
              >
                {eliminandoId !== null ? "Eliminazione..." : "Conferma eliminazione"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default function DiarioImpostazioni({ onCapitaliCambiati } = {}) {
  const [impostazioni, setImpostazioni] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errore, setErrore] = useState(null);

  const ricaricaImpostazioni = useCallback(async () => {
    setLoading(true);
    setErrore(null);
    try {
      const r = await fetch(`${API}/diario/impostazioni`);
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const data = await r.json();
      if (data.errore) throw new Error(data.errore);
      setImpostazioni(data);
    } catch (e) {
      setErrore(e.message || "Errore di rete");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    ricaricaImpostazioni();
  }, [ricaricaImpostazioni]);

  if (loading) {
    return (
      <div style={stili.card}>
        <div style={{ fontSize: 13, color: "#64748B", fontFamily: FONT }}>
          Caricamento impostazioni...
        </div>
      </div>
    );
  }

  if (errore) {
    return (
      <div style={stili.card}>
        <div style={{ fontSize: 13, color: "#C62828", fontFamily: FONT }}>
          Errore caricamento impostazioni: {errore}
        </div>
      </div>
    );
  }

  return (
    <div>
      {/* Sezione 1: Tabella Size% per sistema */}
      <SezioneSizePerSistema />

      {/* Sezione 2: Reminder revisione capitale */}
      <SezioneReminderCapitale
        valoreIniziale={impostazioni?.reminder_capitale_giorni}
        onSalvato={(data) => setImpostazioni(data)}
      />

      {/* Sezione 3: Stagioni */}
      <SezioneStagioni onCapitaliCambiati={onCapitaliCambiati} />
    </div>
  );
}
